/**
 * @generated SignedSource<<1c17cab234cde16741922703cee9a3d0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RemoveUsersFromClassInput = {
  classId: string;
  userIds: ReadonlyArray<string>;
};
export type ClassesRemoveUsersFromClassMutation$variables = {
  input: RemoveUsersFromClassInput;
};
export type ClassesRemoveUsersFromClassMutation$data = {
  readonly removeUsersFromClass: {
    readonly userClassNode: ReadonlyArray<{
      readonly user: {
        readonly classes: ReadonlyArray<{
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly firstName: string | null | undefined;
        readonly gradeLevels: ReadonlyArray<{
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly id: string;
        readonly isActive: boolean;
        readonly lastName: string | null | undefined;
        readonly publicUserId: string | null | undefined;
        readonly roles: ReadonlyArray<{
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly sites: ReadonlyArray<{
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    }> | null | undefined;
  };
};
export type ClassesRemoveUsersFromClassMutation = {
  response: ClassesRemoveUsersFromClassMutation$data;
  variables: ClassesRemoveUsersFromClassMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publicUserId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = [
  (v7/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "SiteNode",
  "kind": "LinkedField",
  "name": "sites",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v10 = [
  (v7/*: any*/),
  (v2/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "GradeLevelNode",
  "kind": "LinkedField",
  "name": "gradeLevels",
  "plural": true,
  "selections": (v10/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClassesRemoveUsersFromClassMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveUsersFromClassPayload",
        "kind": "LinkedField",
        "name": "removeUsersFromClass",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserClassNode",
            "kind": "LinkedField",
            "name": "userClassNode",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleNode",
                    "kind": "LinkedField",
                    "name": "roles",
                    "plural": true,
                    "selections": (v8/*: any*/),
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClassNode",
                    "kind": "LinkedField",
                    "name": "classes",
                    "plural": true,
                    "selections": (v8/*: any*/),
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClassesRemoveUsersFromClassMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RemoveUsersFromClassPayload",
        "kind": "LinkedField",
        "name": "removeUsersFromClass",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserClassNode",
            "kind": "LinkedField",
            "name": "userClassNode",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoleNode",
                    "kind": "LinkedField",
                    "name": "roles",
                    "plural": true,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  (v9/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClassNode",
                    "kind": "LinkedField",
                    "name": "classes",
                    "plural": true,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "eb2dc5ddfde904189dccc082a2822626",
    "id": null,
    "metadata": {},
    "name": "ClassesRemoveUsersFromClassMutation",
    "operationKind": "mutation",
    "text": "mutation ClassesRemoveUsersFromClassMutation(\n  $input: RemoveUsersFromClassInput!\n) {\n  removeUsersFromClass(input: $input) {\n    userClassNode {\n      user {\n        id\n        firstName\n        lastName\n        publicUserId\n        isActive\n        roles {\n          name\n          id\n        }\n        sites {\n          id\n          name\n        }\n        classes {\n          name\n          id\n        }\n        gradeLevels {\n          name\n          id\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9a5747f425f4bd333ad0733e8d46e32b";

export default node;
